import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DateUtil, MathUtil } from 'src/app/common/util';
import { ResponseObject } from 'src/app/models/response-object.model';
import { WarehouseResponse } from 'src/app/models/warehouse.model';
import { PurchasesService } from 'src/app/services/purchases.service';
import { WarehouseService } from 'src/app/services/warehouse.service';

@Component({
  selector: 'app-provider-inventory-establishment-report',
  templateUrl: './provider-inventory-establishment-report.component.html',
  styleUrls: ['./provider-inventory-establishment-report.component.scss']
})
export class ProviderInventoryEstablishmentReportComponent implements OnInit {
  start: any = "";
  end: any = "";
  type = 2;
  warehouse = null;
  @Input() warehouses: WarehouseResponse[] = [];
  loadingChart = false;
  results = [];

  constructor(
    private toastService: ToastrService,
    private purchaseService: PurchasesService,
    private warehouseService: WarehouseService
  ) {

  }

  ngOnInit(): void {
    var today = new Date(DateUtil.getActualDate());
    this.end = DateUtil.getActualDate().split('T')[0];
    today.setDate(today.getDate() - 30);
    var other = new Date(today);
    var convert = DateUtil.parseDateToMilliseconds(other.toISOString());
    this.start = new Date(convert).toLocaleDateString('en-CA');
    this.updateChart();
  }


  updateChart() {
    this.loadingChart = true;
    document.getElementById("provider-inventory-establishment")['innerHTML'] = "";
    if (this.warehouse != null) {
      this.purchaseService.getProviderInventory(
        this.warehouse,
        DateUtil.parseDateToMilliseconds(this.start),
        DateUtil.parseDateToMilliseconds(this.end)
      ).subscribe({
        next: (response: ResponseObject) => {
          this.results = response.data;
          this.buildChart();
          this.loadingChart = false;
        },
        error: (error: HttpErrorResponse) => {
          this.loadingChart = false;
          this.toastService.error(error.error.message);
        }
      });
    } else {
      this.purchaseService.getProviderInventoryGeneral(
        DateUtil.parseDateToMilliseconds(this.start),
        DateUtil.parseDateToMilliseconds(this.end)
      ).subscribe({
        next: (response: ResponseObject) => {
          this.results = response.data;
          this.buildChart();
          this.loadingChart = false;
        },
        error: (error: HttpErrorResponse) => {
          this.loadingChart = false;
          this.toastService.error(error.error.message);
        }
      });
    }
  }

  buildChart() {
    var response = this.results;
    const options = {
      chart: {
        height: 350,
        type: 'bar',
      },
      dataLabels: {
        enabled: true
      },
      stroke: {
        curve: 'smooth'
      },
      series: [{
        name: 'Totales',
        data: (response.length > 0) ? [response[0].totalInventory ? response[0].totalInventory : 0,
        response[0].totalProviders ? response[0].totalProviders : 0] : [0, 0]
      }],
      xaxis: {
        type: 'Mes',
        categories: ["Inventario", "Proveedores"],
      },
      yaxis: {
        labels: {
          formatter: function (val) {
            return MathUtil.formatCurrency(val);
          }
        }

      },
      legend: {
        offsetY: -10,
      }
    }
    if (this.results.length > 0 && this.results[0].totalInventory != null && this.results[0].totalProviders != null) {
      const chart = new ApexCharts(
        document.querySelector("#provider-inventory-establishment"),
        options
      );
      chart.render();
    } else {
      this.results = [];
    }
  }

}

